var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('input',{directives:[{name:"icheck-style",rawName:"v-icheck-style",value:(_vm.model),expression:"model"}],attrs:{"type":_vm.inputtype,"id":_vm.Tid},domProps:{"value":_vm.tvalue,"checked":_vm.model.indexOf(_vm.tvalue)>-1}}),_c('label',{attrs:{"for":_vm.Tid}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }